module.exports = __webpack_public_path__ + "assets/logowhite.aa57c85b.svg";